import { HostService } from './../host/host.service';
import { Address } from './../../interfaces/address';
import { IngredientService } from './../ingredient/ingredient.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Injectable, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { Subscription } from 'rxjs';
import { Nav, ToastController } from 'ionic-angular';
import { ProductService } from './../product/product.service';
import { PdvService } from '../pdv/pdv.service';
@Injectable()
export class OrdersService {
  @ViewChild(Nav) nav: Nav;
  months = [];
  host: string;
  orderTemp: any = {
    elements: [],
    menus: [],
    amount: 0,
    comment: '',
    elementsNbr: 0,
    discount:0,
    discountValue:0,
    total:0,
    couponCode:0,
    coupon:0,
    couponValue:0,
    couponType:0,
    fees: 0,
    feesLabel: ""
  };
  offerNbrTemp: number = 0;
  public order: BehaviorSubject<any> = new BehaviorSubject<any>({
    elements: [],
    menus: [],
    amount: 0,
    comment: '',
    elementsNbr: 0,
    discount:0,
    discountValue:0,
    total:0,
    couponCode:0,
    coupon:0,
    couponValue:0,
    couponType:0,
    fees: 0,
    feesLabel: ""
  });
  public orderType: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public chosenOrderType: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public soon: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public orderProg: BehaviorSubject<Date> = new BehaviorSubject<Date>(new Date());
  public offerNbr: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public menuTime: BehaviorSubject<number> = new BehaviorSubject<number>(-1);
  public address: BehaviorSubject<Address> = new BehaviorSubject<Address>({
    id: null,
    address: "",
    city: "",
    postalCode: null,
    streetNumber: null,
    streetName: ""
  });
  public enablePayement: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public selectedComp: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public elementsNbr: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  public amountMiniDelivery: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  subscriptions: Subscription[] = [];
  amountMiniMandatory = 0;
  discount=0;
  discountFrom=0;
  couponValue=0;
  constructor(
    private http: HttpClient,
    //  private toastr: ToastrService,
    private ingredientsService: IngredientService,
    private hostService: HostService,
    private productService: ProductService,
    private toastCtrl: ToastController,
    private pdvService: PdvService
  ) {
    this.host = this.hostService.host;
    const date = new Date();
    if (date.getHours() < 16) {
      this.menuTime.next(1);
    } else {
      this.menuTime.next(3);
    }
    this.pdvService.pdv.subscribe(
      (data: any) => {
        this.amountMiniMandatory = data.amountMiniMandatory;
        this.discount = data.discount;
        this.discountFrom = data.discountFrom;
      }
    )
  }

  addElementToOrder(element) {
    this.orderTemp.elements.unshift(element);
    this.changeOrderTotal();
  }

  async addMenu(me) {
    let menu = Object.assign({}, me);
    let m: any = {
      id: menu.id,
      avatar: menu.avatar,
      code: menu.code,
      title: menu.title,
      elements: [],
      additionalOptions: [],
      comment: (menu.comment) ? menu.comment : "",
      price: menu.price,
      offer: menu.offer,
      vat: menu.vat,
      qty: 1,
      total: 0,
      priceWithSupp: Number(menu.price)
    }
    if (menu.additionalOptions.length > 0) {
      m.additionalOptions = menu.additionalOptions.filter(map => map.checked);
      if (m.additionalOptions.length > 0) {
        m.total += m.additionalOptions.reduce((a, b) => +a + +b.price, 0);
      }
    }
    await new Promise((v, x) => {
      let arr = menu.compositions2.map((composition, ind) => {
        if (ind == 0 && composition.length > 0) {
          let arr = composition.map(
            (comp) => {
              if (comp.type == 1) {
                return this.addElementToMenu(comp).then(
                  (e: any) => {
                    m.elements.push(e);
                    m.total += Number(e.totalSupp);
                    return Promise.resolve(true);
                  }
                ).catch(
                  (err) => {
                    return Promise.reject(true);
                  }
                )
              }
              if (comp.type == 2) {
                let arr2 = comp.elements.map(com => {
                  return this.addElementToMenu(com[com.selectedElement]).then(
                    (e: any) => {
                      if (menu.offer != null) {
                        e.priceSuppMenu=0;
                      }
                      m.elements.push(e);
                      m.total += Number(e.totalSupp);
                      m.total += Number(e.priceSuppMenu);
                      return Promise.resolve(true);
                    }).catch(
                      (err) => {
                        return Promise.reject(true);
                      }
                    )
                });
                return Promise.all(arr2).then(
                  () => {
                    return Promise.resolve(true);
                  }
                ).catch(
                  () => {
                    return Promise.reject(true);
                  }
                )
              }
            }
          )
          return Promise.all(arr).then(() => {
            return Promise.resolve(true);
          }).catch(
            (err) => {
              return Promise.reject(true);
            }
          )
        }
      })
      Promise.all(arr).then(() => { v(1) }).catch(
        (err) => {
          return x(true);
        }
      )
    }).then(() => {
      console.log('fin 1')
    }).catch(
      (err) => {
        return Promise.reject(true);
      }
    )

    await new Promise((v, x) => {
      let arr = menu.compositions2.map((composition, ind) => {
        if (ind > 0 && composition.length > 0) {
          let comp = composition[composition.checked];
          if (comp.type == 1) {
            return this.addElementToMenu(comp).then(
              (e: any) => {
                m.elements.push(e);
                m.total += Number(e.totalSupp);
                return Promise.resolve(true);
              }).catch(
                (err) => {
                  return Promise.reject(true);
                }
              )
          }
          if (comp.type == 2) {
            let arr2 = comp.elements.map(com => {
              return this.addElementToMenu(com[com.selectedElement]).then(
                (e: any) => {
                  if (menu.offer != null) {
                    e.priceSuppMenu=0;
                  }
                  m.elements.push(e);
                  m.total += Number(e.totalSupp);
                  m.total += Number(e.priceSuppMenu);
                  return Promise.resolve(true);
                }).catch(
                  (err) => {
                    return Promise.reject(true);
                  }
                )
            });
            return Promise.all(arr2).then(
              () => {
                return Promise.resolve(true);
              }
            ).catch(
              () => {
                return Promise.reject(true);
              }
            )
          }
        }
      })
      Promise.all(arr).then(() => { v(1) }).catch(
        (err) => {
          return x(true);
        }
      )
    }).then(() => {
      console.log('fin 2')
    }).catch(
      (err) => {
        return Promise.reject(true);
      }
    )
    
    if (menu.offer == null) {
      m.total += Number(menu.price);
      this.orderTemp.menus.unshift(m);
      menu.loading = false;
      this.changeOrderTotal();
      return Promise.resolve(true);
    }
    else {
      this.offerNbrTemp++;
      this.offerNbr.next(this.offerNbrTemp);
      let somme = m.elements.map(element => element.price).reduce((a, b) => Number(a) + Number(b));
      let lowerItemPrice = Math.min(...m.elements.map(element => Number(element.price)));
      switch (menu.offer) {
        //1 produit acheté, 1 produit offert (valable sur le moins cher des 2)
        case 1: {
          somme -= lowerItemPrice;
          m.total += somme;
          m.price = somme;
          break;
        }
        //2 produits acheté, le 3ème offert
        case 2: {
          somme -= lowerItemPrice;
          m.total += somme;
          m.price = somme;
          break;
        }
        //1 produit acheté le 2ème à 50%
        case 3: {
          somme -= lowerItemPrice * 0.5;
          m.total += somme;
          m.price = somme;
          break;
        }
        //Un produit acheté le 2ème à 3€
        case 4: {
          somme -= lowerItemPrice;
          somme += 3;
          m.total += somme;
          m.price = somme;
          break;
        }
        //2 produit acheté, 2 produit offert (valable sur les moins chers des 2)
        case 5: {
          let prices = JSON.parse(JSON.stringify(m.elements.map(element => element.price)));
          let lowerItemPrice1 = Math.min(...prices);
          prices.splice(prices.indexOf(lowerItemPrice1), 1);
          let lowerItemPrice2 = Math.min(...prices);
          somme -= lowerItemPrice1;
          somme -= lowerItemPrice2;
          m.total += somme;
          m.price = somme;
          break;
        }
        //Une pizza achetée la 2ème à 5,90€
        case 6: {
          somme -= lowerItemPrice;
          somme += 5.90;
          m.total += somme;
          m.price = somme;
          break;
        }

        //Offre Pizza Moitié Moitié
        case 7: {
          somme -= lowerItemPrice;
          m.total += somme;
          m.price = somme;
          m.title = "Pizza Moitié-Moitié";
          m.elements[0].name = "Moitié " + m.elements[0].name;
          m.elements[1].name = "Moitié " + m.elements[1].name;
          break;
        }
        //2 PIZZA ACHETÉES = 1 OFFERTE +1 BOISSON 1.5 L
        case 8: {
          let elements = JSON.parse(JSON.stringify(m.elements));
          elements.splice(0, 1);
          let somme = elements.map(element => element.price).reduce((a, b) => Number(a) + Number(b));
          let lowerItemPrice = Math.min(...elements.map(element => Number(element.price)));
          somme -= lowerItemPrice;
          m.total += somme;
          m.price = somme;
          break;
        }
        //2 PIZZA ACHETÉES = 1 OFFERTE +1 BOISSON 1.5 L
        case 9: {
          let lenght = m.elements.length / 2;
          let prices = JSON.parse(JSON.stringify(m.elements.map(element => Number(element.price))));
          prices = prices.sort((a, b) => a - b);
          prices.splice(0, lenght);
          let somme = prices.reduce((a, b) => Number(a) + Number(b));
          m.title = (lenght > 1) ? lenght + " Pizza achetées, " + lenght + " Pizza offert" : lenght + " Pizza achetée, " + lenght + " Pizza offert";
          m.total += somme;
          m.price = somme;
          break;
        }

      }
      this.orderTemp.menus.unshift(m);
      menu.loading = false;
      this.changeOrderTotal();
      this.offerNbrTemp++;
      this.offerNbr.next(this.offerNbrTemp);
      return Promise.resolve(true);
    }
  }

  addElementToMenu(element) {
    return new Promise(
      (resolve, x) => {
        if (!element.available) {
          this.displayMessage(element.name + ' indisponible')
          x(true);
          return;
        } else {
          let product = JSON.parse(JSON.stringify(element));
          if (product.custom) {
            if (!element.optionIngredients) {
              this.displayMessage('Merci d\'ajouter les options pour ' + element.name);
              x(true);
              return;
            }
            product.selectedOpt = element.optionIngredients.filter(c => c.disabled == "false" && c.checked);
            if (product.selectedOpt.length == 0) {
              this.displayMessage('Merci d\'ajouter les options pour ' + element.name)
              x(true);
              return;
            }
          }
          let e = {
            id: element.id,
            name: element.name,
            family: element.family,
            comment: '',
            qty: Number(element.quantity),
            size: { id: element.id, label: element.size, level: element.level },
            removedCompositions: element.compositions.filter(c => c.disabled == "false" && c.checked === false),
            supplements: [],
            optionIngredients: (element.optionIngredients) ? element.optionIngredients.filter(c => c.disabled == "false" && c.checked === true) : [],
            price: Number(element.price),
            priceSuppMenu: element.priceSuppMenu,
            totalSupp: 0
          }
          e.removedCompositions = this.orderIngredient(e.removedCompositions);
          e.optionIngredients = this.orderIngredient(e.optionIngredients);
          element.selectedSupp = (element.optionIngredients) ? element.supplements.filter(c => c.disabled == "false" && c.checked === true).map(el => { el.label = el.text; return el }) : [];
          if (element.selectedSupp && element.selectedSupp.length > 0) {
            switch (Number(element.priceSuppApp)) {
              case 1: {
                e.supplements = element.selectedSupp;
                e.totalSupp += element.selectedSupp.reduce((a, b) => +a + +b.price, 0)
                resolve(e);
                break;
              }
              case 2: {
                let arraRquest = [];
                element.selectedSupp.forEach((ele) => {
                  arraRquest.push(this.ingredientsService.getIngredientsCatFamSizeBySize(ele.category, element.family, element.idSize))
                });
                forkJoin(arraRquest).subscribe(
                  (d) => {
                    d.forEach((data: any[], index, array) => {
                      let el = JSON.parse(JSON.stringify(element.selectedSupp[index]));
                      if (data.length > 0) {
                        el.price = Number(data[0].price);
                      }
                      e.totalSupp += Number(el.price);
                      e.supplements.push(el);
                      if (array.length - 1 == index) {
                        resolve(e);
                      }
                    })
                  }
                )
                break;
              }
              case 3: {
                element.selectedSupp.forEach((ele, index, array) => {
                  let el = JSON.parse(JSON.stringify(ele));
                  el.price = Number(element.priceSupp);
                  e.totalSupp += Number(el.price);
                  e.supplements.push(el)
                  if (array.length - 1 == index) {
                    resolve(e);
                  }
                });
                break;
              }
            }
          } else {
            resolve(e);
          }
        }
      }
    )
  }

  displayMessage(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top'
    });
    toast.present();
  }

  clearOrder() {
    this.order.next({
      elements: [],
      menus: [],
      amount: 0,
      comment: '',
      elementsNbr: 0,
      total:0,
      discount:0,
      discountValue:0,
      couponCode:0,
      coupon:0,
      couponValue:0,
      couponType:0,
      fees: 0,
      feesLabel: ""
    })
    this.orderTemp = {
      elements: [],
      menus: [],
      amount: 0,
      comment: '',
      elementsNbr: 0,
      total:0,
      discount:0,
      discountValue:0,
      couponCode:0,
      coupon:0,
      couponValue:0,
      couponType:0,
      fees: 0,
      feesLabel: ""
    }
    this.offerNbr.next(0);
    this.elementsNbr.next(0);
  }

  addOrder(order) {
    order.displayCode = 0;
    return this.http.post(this.host + 'orders', order)
  }

  incrQty(i, j) {
    this.orderTemp.amount += this.orderTemp.elements[i].total / this.orderTemp.elements[i].qty;
    this.orderTemp.elements[i].total += this.orderTemp.elements[i].total / this.orderTemp.elements[i].qty;
    this.orderTemp.elements[i].qty++;
    this.orderTemp.elementsNbr++;
    this.order.next(this.orderTemp);
    this.elementsNbr.next(this.orderTemp.elementsNbr);
    this.changeOrderTotal();
  }

  decrQty(i, j) {
    if (this.orderTemp.elements[i].qty > 1) {
      this.orderTemp.amount -= this.orderTemp.elements[i].total / this.orderTemp.elements[i].qty;
      this.orderTemp.elements[i].total -= this.orderTemp.elements[i].total / this.orderTemp.elements[i].qty;
      this.orderTemp.elements[i].qty--;
      this.orderTemp.elementsNbr--;
      this.order.next(this.orderTemp);
      this.elementsNbr.next(this.orderTemp.elementsNbr);
      this.changeOrderTotal();
    }
  }

  removeElement(i, j) {
    switch (j) {
      case 0: {
        let elementPrice = this.orderTemp.elements[i].total;
        this.orderTemp.amount -= elementPrice;
        this.orderTemp.elementsNbr -= this.orderTemp.elements[i].qty;
        this.orderTemp.elements.splice(i, 1);
        this.order.next(this.orderTemp);
        this.elementsNbr.next(this.orderTemp.elementsNbr);
        this.changeOrderTotal();
        return this.orderTemp.elementsNbr;
      }
      case 1: {
        if (this.orderTemp.menus[i].offer != null) {
          this.orderTemp.offerNbr -= this.orderTemp.menus[i].qty;
        }
        let menuPrice = this.orderTemp.menus[i].total;
        this.orderTemp.amount -= menuPrice;
        this.orderTemp.elementsNbr -= this.orderTemp.menus[i].qty;
        this.orderTemp.menus.splice(i, 1);
        this.order.next(this.orderTemp);
        this.elementsNbr.next(this.orderTemp.elementsNbr);
        this.changeOrderTotal();
        return this.orderTemp.elementsNbr;
      }
    }
  }

  getUserOrders() {
    return this.http.get(this.host + 'orders');
  }

  getOrder(id) {
    return this.http.get(this.host + 'orders/' + id + '/info');
  }

  getOrderElements(id) {
    return this.http.get(this.host + 'orders/' + id + '/elements');
  }

  getOrderMenus(id) {
    return this.http.get(this.host + 'orders/' + id + '/menus');
  }

  getOrderPaymentModes(id) {
    return this.http.get(this.host + 'orders/' + id + '/paymentModes');
  }

  getPayementData(params) {
    return this.http.get(this.host + 'payement', { params: params })
  }

  checkCoupon(coupon) {
    return this.http.get(this.host + 'coupon/'+coupon)
  }

  ngOnDestroy() {
    this.unsubscribe();
  }
  unsubscribe() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }

  orderIngredient(array: any[]) {
    let sortedArray = array.sort((ing1: any, ing2: any) => {
      if (ing1.order < ing2.order) {
        return -1
      }
      if (ing1.order > ing2.order) {
        return 1
      }
      return 0;
    })
    return sortedArray;
  }

  changeOrderTotal() {
    this.orderTemp.amount = 0;
    this.orderTemp.elementsNbr = 0;
    this.orderTemp.elements.forEach(el => {
      this.orderTemp.amount += Number(el.total);
      this.orderTemp.elementsNbr += el.qty
    });
    this.orderTemp.menus.forEach(m => {
      this.orderTemp.amount += Number(m.total);
      this.orderTemp.elementsNbr++;
    });
    if(this.discount>0 && this.orderTemp.amount>=this.discountFrom){
      this.orderTemp.discount=this.discount;
      this.orderTemp.total=this.orderTemp.amount * (100-this.discount)/100;
      this.orderTemp.discountValue=-this.orderTemp.amount*this.discount/100;
    }else{
      this.orderTemp.discount=0;
      this.orderTemp.discountValue=0;
      this.orderTemp.total=this.orderTemp.amount;
    }
    if(this.couponValue>0){
      if(this.orderTemp.couponType==1){
        this.orderTemp.couponValue=-this.couponValue;
      }
      if(this.orderTemp.couponType==2){
        this.orderTemp.couponValue=-this.orderTemp.total*this.couponValue/100;
      }
      this.orderTemp.total=this.orderTemp.total+this.orderTemp.couponValue;
    }
    if (this.orderTemp.fees > 0) {
      this.orderTemp.total = Number(this.orderTemp.total)+Number(this.orderTemp.fees);
    }
    this.order.next(this.orderTemp);
    this.elementsNbr.next(this.orderTemp.elementsNbr);
  }

  checkCoupons(coupon,orderType) {
    return this.http.get(this.host +'orderType/'+orderType+'/coupon/' + coupon)
  }
  addCoupon(dataC) {
    if (dataC.productId > 0) {
        this.productService.getProduct(dataC.productId).subscribe(
            (data: any) => {
                this.productService.getSizesOfProduct(data.id).subscribe(
                    (d) => {
                        delete data.elementOrderType;
                        delete data.elementTime;
                        delete data.family;
                        data.comment = "";
                        data.vat = 10;
                        data.additionalOption = 0;
                        data.size = d[0];
                        data.qty = 1;
                        data.total = 0;
                        this.orderTemp.couponCode = dataC.coupon;
                        this.orderTemp.couponProductId = dataC.productId;
                        this.orderTemp.couponType = dataC.type;
                        this.orderTemp.elements.push(data);
                        this.orderTemp.elementsNbr++;
                        console.log(this.order);
                    }
                )
            }
        )
    } else {
        this.orderTemp.couponCode = dataC.coupon;
        this.orderTemp.coupon = Number(dataC.value);
        this.couponValue = Number(dataC.value);
        this.orderTemp.couponType = dataC.type;
        this.changeOrderTotal();
    }
}

  removeCoupon(data) {
    if (data > 0) {
        this.orderTemp.elements = this.RemoveElementFromObjectArray(data, this.orderTemp.elements);
        this.orderTemp.elementsNbr--;
        this.orderTemp.couponCode = '';
        this.orderTemp.couponValue = 0;
        this.orderTemp.coupon = 0;
        this.orderTemp.couponType = null;
        this.couponValue = 0;
    } else {
        this.orderTemp.couponCode = '';
        this.orderTemp.couponValue = 0;
        this.orderTemp.coupon = 0;
        this.orderTemp.couponType = null;
        this.couponValue = 0;
        this.changeOrderTotal();
    }

}

  addFees(managementFees,managementFeesSiteLabel) {
    this.orderTemp.feesLabel = managementFeesSiteLabel
    this.orderTemp.fees = Number(managementFees);
    this.changeOrderTotal();
  }

  getOrderTicket(id) {
    return this.http.get(this.host + 'ticket/orders/' + id);
  }

  checkOrderPayament(id){
    return this.http.get(this.host+'paid/orders/'+id);
  }

  updateOrderTransaction(params) {
    return this.http.put(this.host + 'orders/' + params.id + '/transaction', { transaction: params.transaction });
  }
  RemoveElementFromObjectArray(key: number, objectArray) {
    objectArray.forEach((value, index) => {
        if (value.id == key) objectArray.splice(index, 1);
    });
    return objectArray;
}
}



// WEBPACK FOOTER //
// ./src/providers/order/orders.service.ts